import { getInitialConfigForDetailsview } from "./appBlock/getDetailsview";
import { getInitialConfigForRecordsview } from "./appBlock/getRecordsview";
import { getInitialConfigForChartBlock } from "./appBlock/getChartBlock";
import { getInitialConfigForProgressBar } from "./appBlock/getProgressBar";
import { getInitialConfigForKanban } from "./appBlock/getKanban";
import { getInitialConfigForPivotChart } from "./appBlock/getPivotchart";

export const getInitialConfigForApplicationBlocks = (type, config, options) => {
  switch (type) {
    case "recordsview":
      return getInitialConfigForRecordsview(config, options);
    case "detailsview":
    case "activitycard":
      return getInitialConfigForDetailsview(config, options);
    case "chart":
      return getInitialConfigForChartBlock(config, options);
    case "progress-bar":
      return getInitialConfigForProgressBar(config, options);
    case "kanban":
      return getInitialConfigForKanban(config, options);
    case "pivotcharts":
      return getInitialConfigForPivotChart(config, options);
    default:
      return { config };
  }
};
